import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "router-content" }
const _hoisted_2 = { class: "custom-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://janov-sy.cz",
  target: "_blank"
}, "Obec Janov", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" © Všechna práva vyhrazena ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Menu),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("footer", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(new Date().getFullYear()) + " ", 1),
          _hoisted_3,
          _hoisted_4
        ])
      ])
    ])
  ], 64))
}